<script lang="ts">
    import { apiBaseURL } from "../config"
    import { i18n } from "../store"

    export let position: Seite
</script>

<div class="post">
    <div class="item">
        <div class="image">
            <img
                src="{apiBaseURL +
                    '/seiten/' +
                    position.id +
                    '/' +
                    position.icon?.src}"
                alt=""
            />
        </div>
        <div class="text">
            <div class="inner">
                <h3>{position.titel}</h3>
                <p>
                    {@html position.teaserText}
                </p>
            </div>
            <a href="/{position.pfad}" class="btn">{$i18n("mehr")}</a>
        </div>
    </div>
</div>

<style lang="less">
    @import "../css/base.less";

    // List
    .post {
        width: 50%;
        @media (max-width: 740px) {
            width: 100%;
        }
    }
    .item {
        background: #fff;
        -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        .transition();
        .flex();
        .image {
            width: 80px;
            flex-shrink: 0;
            background-image: linear-gradient(
                    to bottom,
                    rgba(51, 51, 51, 0),
                    #333333
                ),
                linear-gradient(to top, #878787, #878787);
            padding: 20px;
            img {
                width: 100%;
            }
        }
        .text {
            padding: 20px;
            .flex();
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            h3 {
                font-size: 1.1rem;
                margin: 0px 0px 20px 0px;
                color: @textcolor;
                a {
                    color: @textcolor;
                    .transition();
                }
            }
        }
        &:hover {
            -webkit-box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
        }
    }
</style>
